import React, { Component } from 'react';
import { connect } from 'react-redux';

import { clearCustomerAlerts } from 'actions/alertActions';

import FlashMessage from 'components/alerts/FlashMessage/FlashMessage';
import SidebarLayout from 'components/layouts/SidebarLayout/SidebarLayout';
import AdminNavBar from 'components/navigation/AdminNavBar';

class Admin extends Component {
  renderUpdateSuccess(customerUpdated) {
    setTimeout(() => {
      this.props.clearCustomerAlerts();
    }, 5000);

    return (
      <FlashMessage className="CustomerSuccess" alertType="success">
        {customerUpdated.message}
      </FlashMessage>
    );
  }

  render() {
    const { customerUpdated } = this.props.alerts;

    return (
      <div className="Admin">
        {customerUpdated ? this.renderUpdateSuccess(customerUpdated) : ''}

        <SidebarLayout
          smHiddenDown
          sidebarComponent={<AdminNavBar />}
          children={this.props.children}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    alerts: state.alerts
  };
}

export default connect(
  mapStateToProps,
  { clearCustomerAlerts }
)(Admin);



// WEBPACK FOOTER //
// ./src/pages/admin/index.js